import { z } from "zod";

import { OAUTH_CLIENT_CATEGORIES, OAUTH_CLIENT_STATUSES } from "~/v2/api/oauth";
import { MAX_REDIRECT_URIS, MAX_SCREENSHOTS } from "./SubmitApp.utils";

const REQUIRED_MESSAGE = "This field is required";
const URL_MESSAGE = "URLs must start with http:// or https://.";
const REDIRECT_URI_MESSAGE = "URLs must start with https:// or http://";
const HTTP_URL_PATTERN = /^https?:\/\//;

const optionalHttpUrl = z
  .string()
  .refine((value) => value === "" || HTTP_URL_PATTERN.test(value), URL_MESSAGE);

const optionalRedirectUri = z
  .string()
  .refine(
    (value) => value === "" || HTTP_URL_PATTERN.test(value),
    REDIRECT_URI_MESSAGE,
  );

export const ZSubmitAppForm = z.object({
  name: z
    .string({ error: REQUIRED_MESSAGE })
    .min(1, REQUIRED_MESSAGE)
    .max(30, "Maximum 30 characters"),
  redirect_uri: z
    .array(optionalRedirectUri)
    .max(
      MAX_REDIRECT_URIS,
      `Maximum ${MAX_REDIRECT_URIS} redirect URIs permitted`,
    )
    .transform((redirectUris) => redirectUris.filter(Boolean)),
  description: z
    .string({ error: REQUIRED_MESSAGE })
    .min(1, REQUIRED_MESSAGE)
    .max(1000, "Maximum 1000 characters"),
  url: z
    .string({ error: REQUIRED_MESSAGE })
    .min(1, REQUIRED_MESSAGE)
    .regex(HTTP_URL_PATTERN, URL_MESSAGE),
  terms_of_use: optionalHttpUrl,
  privacy_policy: optionalHttpUrl,
  logo: z.string().default(""),
  status: z.enum(OAUTH_CLIENT_STATUSES).default("DISABLED"),
  screenshots: z
    .array(z.string())
    .max(MAX_SCREENSHOTS, `Maximum ${MAX_SCREENSHOTS} screenshots permitted`),
  categories: z
    .array(z.enum(OAUTH_CLIENT_CATEGORIES), {
      error: REQUIRED_MESSAGE,
    })
    .min(1, REQUIRED_MESSAGE),
});

export type SubmitAppFormValues = z.infer<typeof ZSubmitAppForm>;

export const SUBMIT_APP_DEFAULT_VALUES: SubmitAppFormValues = {
  name: "",
  redirect_uri: [],
  description: "",
  url: "",
  terms_of_use: "",
  privacy_policy: "",
  logo: "",
  status: "DISABLED",
  screenshots: [],
  categories: [],
};
